import store from "@/store";
export function localizedDeliveryDescription(delivery) {
    const name = delivery.descriptionDelivery.find(localizedNames => localizedNames.language == store.state.language);
    if (name != undefined) {
        return name.text;
    }
    return delivery.descriptionDeliveryDefault;
}
export function localizedDeliveryEstimate(delivery) {
    const name = delivery.descriptionEstimates.find(localizedNames => localizedNames.language == store.state.language);
    if (name != undefined) {
        return name.text;
    }
    return '';
}
